import { useJwtTokenStore } from '~/stores/jwtTokenStore';

export default defineNuxtRouteMiddleware(async () => {
    useGqlToken(useJwtTokenStore().getMrAdminApiToken, { client: 'adminApi' });
    useGqlHost(useRuntimeConfig().public.adminApi.url, 'adminApi');
});
